const TRUSTED_SHOPS_IDS: Record<string, string> = {
  "nl-nl": "XD0C4D21CAD6C552BE97F02FB8B2E0527",
  "nl-be": "X53E1F7D83A871329242757D21BE6E5D2",
  "de-de": "X192B860A5A84E9BCE9EF468F61CECDFE",
  "fr-fr": "X5A8FBF29E773717750C8DD046E05E670",
} as const;

export const getTrustedShopsId = (locale: string) => {
  return TRUSTED_SHOPS_IDS[locale] || null;
}